import { render, staticRenderFns } from "./edutalk-information.vue?vue&type=template&id=61d17533&scoped=true"
import script from "./edutalk-information.vue?vue&type=script&lang=js"
export * from "./edutalk-information.vue?vue&type=script&lang=js"
import style0 from "./edutalk-information.vue?vue&type=style&index=0&id=61d17533&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61d17533",
  null
  
)

export default component.exports